import { type ReactNode, Suspense } from 'react';

function PageLoader() {
  return (
    <div className="erp-page-loader" role="status" aria-busy="true" aria-label="Loading page">
      <span className="sr-only">Loading…</span>
    </div>
  );
}

export function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}
